const betterads = `
prestitial_enabled = 1; // this value will get override in prebid.js
postitial_enabled = 1; // this value will get override in prebid.js
catfish_enabled = 1; // this value will get override in prebid.js';
`;

export default betterads;
